import React from 'react';
export const Ssvg = ({ icon, className, aspectRatio }) => {
    return (React.createElement("s-svg", { "data-icon": icon, ...className !== undefined && { class: className }, ...aspectRatio !== undefined && { style: { aspectRatio } } }));
};
